import ModuleList from './List';
function Modules() {
    return (
        <div className='row'>
            <div className='col-md-8'>
            <ModuleList />
            </div>
        </div>
    );
}
export default Modules;